<template>
  <div>
    <LlAppFixedToolBar />
    <LlScrollableWrap>
      <LlScrollableBlock title="管理">
        <ImgButtonList isRow size="middle" :buttonList="_managementButton" />
      </LlScrollableBlock>
    </LlScrollableWrap>
  </div>
</template>

<script>
import config from '@/__config';
import S_scope from '@/service/api/v1/scope';

export default {
  computed: {
    _currentFactorySubscriptions() {
      return this.$store.state.app.factory.subscriptions
        ? this.$store.state.app.factory.subscriptions
        : [];
    },
    _managementButton() {
      const _managementList = [
        {
          image: require('@/assets/image/file.jpg'),
          textLabel: '任務',
          link: '/tasks',
          module: 'task',
          disabled:
            !this._currentFactorySubscriptions.includes('task') ||
            (!S_scope.$_isAvailable(['task-read']) && !S_scope.$_isAvailable(['task-read-all'])),
          disabledText: this.$_getDisabledText('task'),
          disabledIcon: 'icon-lock',
        },
        {
          image: require('@/assets/image/check.jpg'),
          textLabel: '日常自檢',
          link: '/checklists',
          module: 'checklist',
          disabled:
            !this._currentFactorySubscriptions.includes('checklist') ||
            !S_scope.$_isAvailable(['checklist-read']),
          disabledText: this.$_getDisabledText('checklist'),
          disabledIcon: 'icon-lock',
        },
        {
          image: require('@/assets/image/change.jpg'),
          textLabel: '變動管理',
          link: '/changes',
          module: 'change',
          disabled:
            !this._currentFactorySubscriptions.includes('change') ||
            !S_scope.$_isAvailable(['change-read']),
          disabledText: this.$_getDisabledText('change'),
          disabledIcon: 'icon-lock',
        },
        {
          image: require('@/assets/image/license.jpg'),
          textLabel: '證照管理',
          link: '/licenses',
          module: 'license',
          disabled:
            !this._currentFactorySubscriptions.includes('license') ||
            !S_scope.$_isAvailable(['license-read']),
          disabledText: this.$_getDisabledText('license'),
          disabledIcon: 'icon-lock',
        },
        {
          image: require('@/assets/image/training.jpg'),
          textLabel: '教育訓練',
          disabled:
            !this._currentFactorySubscriptions.includes('training') ||
            !S_scope.$_isAvailable(['internal-training-read']),
          link: '/trainings',
          module: 'training',
          disabledText: this.$_getDisabledText('training'),
          disabledIcon: 'icon-lock',
        },
        {
          image: require('@/assets/image/event.jpg'),
          textLabel: '風險事件',
          link: '/events',
          module: 'event',
          disabled:
            !this._currentFactorySubscriptions.includes('event') ||
            !S_scope.$_isAvailable(['event-read']),
          disabledText: this.$_getDisabledText('event'),
          disabledIcon: 'icon-lock',
        },
        {
          image: require('@/assets/image/audit.jpg'),
          textLabel: '稽核管理',
          link: '/audits',
          module: 'audit',
          disabled:
            !this._currentFactorySubscriptions.includes('audit') ||
            !S_scope.$_isAvailable(['audit-read']),
          disabledText: this.$_getDisabledText('audit'),
          disabledIcon: 'icon-lock',
        },
        {
          image: require('@/assets/image/contractor.jpg'),
          textLabel: '承攬商管理',
          link: '/contractors',
          module: 'contractor',
          disabled:
            !this._currentFactorySubscriptions.includes('contractor') ||
            !S_scope.$_isAvailable(['contractor-read']),
          disabledText: this.$_getDisabledText('contractor'),
          disabledIcon: 'icon-lock',
        },
        {
          image: require('@/assets/image/contractor_operation.jpg'),
          textLabel: '進場管理',
          link: '/contractor-operations',
          module: 'contractor',
          disabled:
            !this._currentFactorySubscriptions.includes('contractor') ||
            !S_scope.$_isAvailable(['contractor-enter-record-read']),
          disabledText: this.$_getDisabledText('contractor'),
          disabledIcon: 'icon-lock',
        },
        {
          image: require('@/assets/image/file.jpg'),
          textLabel: '文件檔案庫',
          disabled: !this._currentFactorySubscriptions.includes('file'),
          link: '/files?tab=thisUnit',
          module: 'file',
          disabledText: this.$_getDisabledText('file'),
          disabledIcon: 'icon-lock',
        },
        {
          image: require('@/assets/image/file.jpg'),
          textLabel: '議事',
          disabled:
            !this._currentFactorySubscriptions.includes('meeting') ||
            (!S_scope.$_isAvailable(['meeting-read']) &&
              !S_scope.$_isAvailable(['meeting-template-read'])),
          link: '/meetings',
          module: 'meeting',
          disabledText: this.$_getDisabledText('meeting'),
          disabledIcon: 'icon-lock',
        },
        {
          image: require('@/assets/image/file.jpg'),
          textLabel: '內規管理',
          link: '/guideline-admins',
          module: 'guideline',
          disabled: !this._currentFactorySubscriptions.includes('guideline'),
          disabledText: this.$_getDisabledText('guideline'),
          disabledIcon: 'icon-lock',
        },
        {
          image: require('@/assets/image/check.jpg'),
          textLabel: 'QRcode工具',
          link: '/qrcodes',
          module: 'qrcode',
          disabled:
            !this._currentFactorySubscriptions.includes('qrcode') ||
            !S_scope.$_isAvailable(['qrcode-read']),
          disabledText: this.$_getDisabledText('qrcode'),
          disabledIcon: 'icon-lock',
        },
        {
          image: require('@/assets/image/file.jpg'),
          textLabel: '操作記錄',
          link: '/logs',
          module: 'log',
          disabled:
            !this._currentFactorySubscriptions.includes('log') ||
            !S_scope.$_isAvailable(['log-manage']),
          disabledText: this.$_getDisabledText('log'),
          disabledIcon: 'icon-lock',
        },
      ];
      // 客戶包只顯示有打包的模組；線上包 isModuleEnabled 恆為 true
      return _managementList.filter(item => config.build.isModuleEnabled(item.module));
    },
  },
  methods: {
    $_getDisabledText(examSubscription) {
      return this._currentFactorySubscriptions.includes(examSubscription)
        ? '您無此權限'
        : '無訂閱此模組';
    },
  },
};
</script>
